<template>
  <!-- Status pill that pairs color WITH an icon + label, so meaning never
       depends on color alone (accessibility: colorblind-safe). -->
  <v-chip :size="size" :color="chipColor" variant="flat" class="int-status-chip">
    <v-icon start size="14">{{ chipIcon }}</v-icon>
    {{ status }}
  </v-chip>
</template>

<script>
import { statusColor } from '@/theme/semantic';

const STATUS_ICONS = {
  Todo: 'mdi-circle-outline',
  'In Progress': 'mdi-progress-clock',
  'On Hold': 'mdi-pause-circle-outline',
  Cancelled: 'mdi-close-circle-outline',
  Done: 'mdi-check-circle',
  Open: 'mdi-alert-circle-outline',
  Resolved: 'mdi-check-circle',
  Closed: 'mdi-lock-outline',
  Pass: 'mdi-check-circle',
  Fail: 'mdi-close-circle',
  Blocked: 'mdi-cancel',
  Skipped: 'mdi-debug-step-over',
  Untested: 'mdi-help-circle-outline',
};

export default {
  name: 'StatusChip',
  props: {
    status: { type: String, default: '' },
    size: { type: String, default: 'small' },
  },
  computed: {
    chipColor() {
      return statusColor(this.status);
    },
    chipIcon() {
      return STATUS_ICONS[this.status] || 'mdi-circle-small';
    },
  },
};
</script>

<style scoped>
.int-status-chip {
  font-weight: 600;
}
</style>
